import { z } from "zod";

export const CONTACT_SUBJECT_VALUES = ["bug", "feature", "account_deletion", "other"] as const;

export const ContactSubject = {
	BUG: "bug",
	FEATURE: "feature",
	ACCOUNT_DELETION: "account_deletion",
	OTHER: "other",
} as const;

export type ContactSubject = (typeof ContactSubject)[keyof typeof ContactSubject];

export const contactRequestSchema = z.object({
	email: z.email().max(320),
	subject: z.enum(CONTACT_SUBJECT_VALUES),
	message: z.string().trim().min(10).max(4000),
	captcha_token: z.string().min(1),
});

export type ContactRequestPayload = z.infer<typeof contactRequestSchema>;

export const ME_CONTACT_SUBJECT_VALUES = [ContactSubject.BUG, ContactSubject.FEATURE, ContactSubject.OTHER] as const;

export const meContactRequestSchema = contactRequestSchema.omit({ captcha_token: true, email: true }).extend({
	subject: z.enum(ME_CONTACT_SUBJECT_VALUES),
});

export type MeContactRequestPayload = z.infer<typeof meContactRequestSchema>;
